import componentsAPI from '../../../api/components'
import * as errorMessages from '../../../error-messages'
import { reorder } from '../../../helpers'

export default {
  async indexNoPaginate({commit, rootState}) {
    const tenantID = rootState.tenants.current.id
    const moduleID = rootState.modules.current.id
    const resp = await componentsAPI.index({
      tenantID,
      moduleID,
      short: true,
      showHidden: true
    })
    const index = resp.data.data

    commit('setComplete', {index})
  },

  async index({commit, rootState, state}, view) {
    const tenantID = rootState.tenants.current.id
    const moduleID = rootState.modules.current.id
    const meta = state.views[view].meta
    const params = {tenantID, moduleID, paginate: meta.paginate}

    if (typeof(meta.showHidden) !== 'undefined' && meta.showHidden !== null) {
      params.showHidden = meta.showHidden
    }
    if (typeof(meta.active) !== 'undefined' && meta.active !== null) {
      params.active = meta.active
    }
    if (typeof(meta.archived) !== 'undefined' && meta.archived !== null) {
      params.archived = meta.archived
    }
    if (typeof(meta.order) !== 'undefined' && meta.order !== null) {
      params.order = meta.order
    }
    if (typeof(meta.desc) !== 'undefined' && meta.desc !== null) {
      params.desc = meta.desc
    }

    // don't set page if search is set
    if (typeof(meta.search) !== 'undefined' && meta.search !== null) {
      params.search = meta.search
    } else if (typeof(meta.current_page) !== 'undefined' && meta.current_page !== null) {
      params.page = meta.current_page
    }

    commit('setFetchingForView', {view, value: true})

    const resp = await componentsAPI.index(params)
    const index = resp.data.data
    const updatedMeta = resp.data.meta

    commit('setView', {view, index, meta: updatedMeta})
    commit('setFetchingForView', {view, value: false})
  },

  async show({commit, rootState}, {id, moduleID}) {
    const tenantID = rootState.tenants.current.id
    if (!moduleID) {
      moduleID = rootState.modules.current.id
    }
    const resp = await componentsAPI.show({tenantID, moduleID, componentID: id})
    const component = resp.data.data
    commit('setCurrent', component)
  },

  async store({commit, state, rootState, dispatch}) {
    const tenantID = rootState.tenants.current.id
    const moduleID = rootState.modules.current.id
    const formData = new FormData()

    formData.append('name', state.forms.store.fields.name)
    formData.append('description', state.forms.store.fields.description)

    // existing image
    if (state.forms.store.fields.imageID) {
      formData.append('image_id', state.forms.store.fields.imageID)

    // new image
    } else if (state.forms.store.fields.image) {
      formData.append('image', state.forms.store.fields.image)
      formData.append('image_name', state.forms.store.fields.imageName)
    }

    commit('forms/store/resetErrors')
    commit('forms/store/resetSuccess')
    commit('forms/store/setSaving', true)

    let resp, newComponent
    let success = true

    try {
      // store the component
      resp = await componentsAPI.store({tenantID, moduleID, data: formData})
      newComponent = resp.data.data

    } catch (err) {
      success = false

      if (err.response) {
        if (err.response.status === 422) {
          const errors = err.response.data.errors

          if (errors.image) {
            for (let i = 0; i < errors.image.length; i++) {
              if (errors.image[i].includes('required')) {
                errors.image[i] = errorMessages.IMAGE_REQUIRED
              }
            }
            commit('forms/store/setFieldErrors', {
              field: 'other',
              errors: errors.image
            })
          }

          commit('forms/store/setErrors', errors)
        }
      }
    }

    commit('forms/store/setSuccess', success)
    commit('forms/store/setSaving', false)

    if (success) {
      commit('setCurrent', newComponent)
      dispatch('index', state._defaultView)
    }
  },

  async update({commit, state, rootState, dispatch}, {componentID}) {
    const tenantID = rootState.tenants.current.id
    const moduleID = rootState.modules.current.id
    const data = new FormData()

    if (state.forms.update.fields.active !== null) {
      data.append('is_active', state.forms.update.fields.active)
    }

    if (state.forms.update.fields.name) {
      data.append('name', state.forms.update.fields.name)
    }

    if (state.forms.update.fields.description) {
      data.append('description', state.forms.update.fields.description)
    }

    if (state.forms.update.fields.image) {
      data.append('image', state.forms.update.fields.image)
    }

    if (state.forms.update.fields.imageName) {
      data.append('image_name', state.forms.update.fields.imageName)
    }

    // existing image
    if (state.forms.update.fields.imageID) {
      data.append('image_id', state.forms.update.fields.imageID)

      // new image
    } else if (state.forms.update.fields.image) {
      data.append('image', state.forms.update.fields.image)
      data.append('image_name', state.forms.update.fields.imageName)
    }

    commit('forms/update/resetErrors')
    commit('forms/update/resetSuccess')
    commit('forms/update/setSaving', true)

    let resp, updatedComponent
    let success = true
    try {

      // update the component
      resp = await componentsAPI.update({tenantID, moduleID, componentID, data})
      updatedComponent = resp.data.data

    } catch (err) {
      success = false

      if (err.response) {
        if (err.response.status === 422) {
          const errors = err.response.data.errors
          commit('forms/update/setErrors', errors)
        }
      }
    }

    commit('forms/update/setSaving', false)
    commit('forms/update/setSuccess', success)

    if (success) {
      commit('upsert', {view: state._defaultView, entity: updatedComponent})
      commit('setCurrent', updatedComponent)
      dispatch('index', state._defaultView)
    }
  },

  async reorder({commit, state, rootState, dispatch}, {componentID, direction}) {
    const tenantID = rootState.tenants.current.id
    const moduleID = rootState.modules.current.id

    let components = state.complete.ids.map((id) => state.complete.index[id])
    components = reorder({elements: components, id: componentID, direction})

    // update the store
    commit('setComplete', {index: components})

    components.map((element) => {
      return {
        id: element.id,
        order: element.order
      }
    })

    const data = { components }
    commit('setFetchingForView', {view: state._defaultView, value: true})
    await componentsAPI.bulkUpdate({tenantID, moduleID, data})
    dispatch('index', state._defaultView)
  },

  async hide({commit, rootState}, {componentIDs}) {
    const tenantID = rootState.tenants.current.id
    const moduleID = rootState.modules.current.id
    componentsAPI.hide({tenantID, moduleID, data: componentIDs})
  },

  async restore({commit, state, rootState, dispatch}, id) {
    const tenantID = rootState.tenants.current.id
    const moduleID = rootState.modules.current.id
    const data = { 'is_deleted': false, 'is_restored': true, 'is_active': true }

    commit('setFetchingForView', {view: state._defaultView, value: true})
    commit('setFetchingForView', {view: state._archivedView, value: true})
    await componentsAPI.update({tenantID, moduleID, componentID: id, data})
    dispatch('index', state._defaultView)
    dispatch('index', state._archivedView)
  },

  async archive({commit, state, rootState, dispatch}, id) {
    const tenantID = rootState.tenants.current.id
    const moduleID = rootState.modules.current.id

    commit('setFetchingForView', {view: state._defaultView, value: true})
    commit('setFetchingForView', {view: state._archivedView, value: true})
    await componentsAPI.destroy({tenantID, moduleID, componentID: id})
    dispatch('index', state._defaultView)
    dispatch('index', state._archivedView)
  },

  async copy({commit, state, rootState, dispatch}, id) {
    const tenantID = rootState.tenants.current.id
    const moduleID = rootState.modules.current.id
    commit('setFetchingForView', {view: state._defaultView, value: true})
    await componentsAPI.copy({tenantID, moduleID, componentID: id})
    dispatch('index', state._defaultView)
  },

  async move({commit, state, rootState, dispatch}, {srcID, destID}) {
    const tenantID = rootState.tenants.current.id
    const moduleID = rootState.modules.current.id
    const data = { 'module_id': destID }
    commit('setFetchingForView', {view: state._defaultView, value: true})
    await componentsAPI.move({tenantID, moduleID, componentID: srcID, data})
    dispatch('index', state._defaultView)
  }

}



// WEBPACK FOOTER //
// ./src/store/modules/components/actions.js